<template>
  <div>
    <DayPilotScheduler id="dp" :config="config" ref="scheduler" />
    <div class="wrap">
      <div class="content">
      </div>
    </div>
  </div>
</template>

<script>
import { DayPilot, DayPilotScheduler } from 'daypilot-pro-vue'
import moment from "moment"
export default {
  name: 'Scheduler',
  props: {
    items: {
        type: Array,
        default(rawProps) {
            return []
        },
    },
    staffs: {
        type: Array,
        default(rawProps) {
            return []
        },
    },
  },
  data: function () {
    let now = moment()
    return {
      events: [],
      config: {
        timeHeaders: [
          {
            "groupBy": "Month",
            "format": "MMMM yyyy",
          },
          {
            "groupBy": "Day",
            "format": "d",
          },
        ],
        scale: "Day",
        days: DayPilot.Date.today().daysInMonth(),
        startDate: DayPilot.Date.today().firstDayOfMonth(),

        cellWidthSpec: "Fixed",
        cellWidth: 100,
        rowMinHeight: 50,
        eventHeight: 50,
        // onBeforeCellRender: (args) => {
        //   args.cell.backColor = "#ffffd5";
        // },
        onBeforeEventRender: (args) => {
          let element = args.e.leave
          let color = 'bg-warning'
          if (element.rejectedDate) {
            color = 'bg-danger'
          } else if (element.approvedDate) {
            color = 'bg-success'
          }

          args.e.cssClass = color;
          args.e.fontColor = "#fff";
          args.e.backColor = "#0000";
          args.e.barHidden = "#0000";
          args.e.barColor = "#0000";
          args.e.barBackColor = "#0000";
          // args.e.html = `<div class="card w-100 border-left-primary bg-success"><div class="card-body text-start p-2"><div class="row no-gutters"><div class="col-auto"><img src="${args.e.leave.image || args.e.leave.icon}" class="pt-1" style="height: 25px; width: 25px;"></div><div class="col pl-2"><b>${args.e.text.replaceAll(' ', '<br>')}</b></div></div></div></div>`
          args.e.html = `<div class="w-100 text-center align-middle">${args.e.text.replaceAll(' ', '<br>')}</div>`
          // args.e.moveDisabled = true;
          // args.e.bubbleHtml = "Moving of this event is disabled.";
          // args.e.areas = [{html:"Disabled", right: 2, bottom: 2}];
        },
        
        timeRangeSelectedHandling: "Enabled",
        onTimeRangeSelected: async (args) => {
          args.preventDefault()
          if(moment(args.start.value).unix() < moment().add(1, 'day').startOf('day').unix()) {
            return
          }
          this.$emit('showModalAdd', args.start, args.resource)
        },
        eventMoveHandling: 'Disabled',
        // eventMoveHandling: "Update",
        // onEventMoved: (args) => {
        //   args.control.message("Event moved: " + args.e.text());
        // },
        eventResizeHandling: 'Disabled',
        // eventResizeHandling: "Update",
        // onEventResized: (args) => {
        //   args.control.message("Event resized: " + args.e.text());
        // },
        // eventDeleteHandling: "Update",
        // onEventDeleted: (args) => {
        //   args.control.message("Event deleted: " + args.e.text());
        // },
        eventClickHandling: "Enabled",
        onEventClick: (args) => {
          args.preventDefault()
          this.$emit('showModalEdit', args.e.data.leave)
        },
        eventHoverHandling: "Disabled",
        // eventHoverHandling: "Bubble",
        // bubble: new DayPilot.Bubble({
        //   onLoad: (args) => {
        //     // if event object doesn't specify "bubbleHtml" property 
        //     // this onLoad handler will be called to provide the bubble HTML
        //     args.html = "Event details";
        //   }
        // }),

        treeEnabled: true,
        resources: [],
        events: [],
      }
    }
  },
  components: {
    DayPilotScheduler
  },
  computed: {
    // DayPilot.Scheduler object - https://api.daypilot.org/daypilot-scheduler-class/
    scheduler: function () {
      return this.$refs.scheduler.control;
    }
  },
  methods: {
    setDate() {

    },
    setData(leaves) {
      let resources = []
      for(let staff of this.staffs) {
        resources.push({ name: staff['name'] + '\n' + staff['mobile'], id: staff['staffID'] })
      }
      this.config.resources = resources

      let events = []
      for(let leave of leaves) {
        let start = moment.unix(leave['startDate']).format('YYYY_MM_DDTHH:mm:ss')
        let end = moment.unix(leave['stopDate']).format('YYYY_MM_DDTHH:mm:ss')
        let text = leave['type']
        events.push({ id: leave['leaveID'], start, end, text, resource: leave['staffID'], leave })
      }
      this.config.events = events;
    },
  },
  mounted() {
    // this.loadEvents();
    // this.scheduler.message("Welcome!");
  },
}
</script>

<style>
.wrap {
  display: flex;
}

.left {
  margin-right: 10px;
}

.content {
  flex-grow: 1;
}


.calendar_default_event_inner {
  background: #2e78d6;
  color: white;
  border-radius: 5px;
  opacity: 0.9;
}
</style>
